<!--
 * @Author: your name
 * @Date: 2021-07-27 20:30:08
 * @LastEditTime: 2021-09-07 11:25:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\pages\exclusivePurchase\index.v
 e
-->
<template>
  <div class="exclusive-wrapper">
    <div class="exclusive-content">
      <basePurchase :typeObj="typeObj" v-if="activeType!=1"></basePurchase>
      <treePurchase :activeType='activeType'  @getChildrenData="getChildrenData1" v-show="(activeType==''||activeType==1) && (activeName=='first' || activeName=='null')">
         <el-tabs class="tabs-area" v-model="activeName" type="card" @tab-click="handleClick" v-show="activeType==1 && activeName=='first'">
          <el-tab-pane label="商品资源配置" name="first"> </el-tab-pane>
          <el-tab-pane label="页面内容配置" name="second"> </el-tab-pane>
        </el-tabs>
      </treePurchase>
      <imgPurchase ref="imgPurchase" :activeType='activeType'  @getChildrenData="getChildrenData2" @submitData="submit" v-show="(activeType==''||activeType==1) && (activeName=='second' || activeName=='null')" >
        <el-tabs class="tabs-area" v-model="activeName" type="card" @tab-click="handleClick" v-show="activeType==1 && activeName=='second'">
          <el-tab-pane label="商品资源配置" name="first"> </el-tab-pane>
          <el-tab-pane label="页面内容配置" name="second"> </el-tab-pane>
        </el-tabs>
      </imgPurchase>
    </div>
    <!-- <div class="exclusive-footer">
     <el-button   :disabled='!templateId'   type="primary" @click="submit">发布采购专属商城</el-button>
    </div> -->
  </div>
</template>
<script>
import basePurchase from "./basePurchase";
import treePurchase from "./treePurchase";
import imgPurchase from "./imgPurchase";
import cmsApi from '../../api/cms/index'
import organizationApi from '../../api/organization/index'
import companyApi from '../../api/company/index'
import  {purchaseUrl} from '../../api/config'
export default {
  components: {
      basePurchase,
      treePurchase,
      imgPurchase,
  },
  created(){
    //  this.getInitStatus()
  },
  computed:{
    ea_userInfo() {
    
      return this.$store.state.USERINFO
    },
  },
  
  data(){
    return{
      purchaseUrl,
      activeName:'null',
      showActive:'',
      statusObj:{
        resourceAllocationIsok:false,
        contentConfigurationIsok:false,
      },
      activeType:'',
      templateId:'',
      typeObj:{
        check1:1,
        check2:1,
      }
 
    }
  },
  
  watch:{
    statusObj:{
      handler: function (val) {
         if(val.resourceAllocationIsok && val.contentConfigurationIsok){
           this.activeType=1;
           this.activeName='first'
         }
      },
      deep: true
    },
    ea_userInfo:{
      immediate:true,
      handler(val){
        if(val.companyId){
          this.getInitStatus()
        }
      },
      deep:true
    }
  },
  methods:{
    getChildrenData1(val){
      this.statusObj.resourceAllocationIsok=val
    },
    getChildrenData2(val){
      this.statusObj.contentConfigurationIsok=val.status
      this.templateId=val.templateId
    },
    
    handleClick(){
       
    },
    getInitStatus(){
      let res1=organizationApi.hasOrganization() //查询某个公司下是否有组织机构数据
      let res2=companyApi.hasMember() // //企业下是否有用户
      let res3=companyApi.hasPurchase() ////企业是否包含采购框架
        Promise.all([res1, res2,res3]).then((result) => {
          let hasOrganization= result[0].data;
          let hasMember=result[1].data;
          let hasPurchase=result[2].data;
          if(hasOrganization&&hasMember){
            this.typeObj.check1=2
          }else{
            this.typeObj.check1=3
          }

          if(hasPurchase){
            this.typeObj.check2=2
          }else{
            this.typeObj.check2=3
          }
        
        })
    },
    async submit(id){
        if(this.typeObj.check2!=2 && !this.statusObj.resourceAllocationIsok){
          this.$message.error('请维护贵企业的采购框架协议或商品资源配置！');
          return
        }
        let params={
            templateId:this.templateId?this.templateId:id,
        }
        let res =await cmsApi.publishPurchaseTemplate(params);
        if(res.code==200){
           this.$message.success('发布成功！');
           this.$refs.imgPurchase.getPurchaseTemplate();
          //  this.toPath('/reviewPurchase')
        }
    },
    toPath(path){
      this.$router.push(path)
    }
  },
  mounted() {
     
  }
}
</script>

<style scoped lang="scss">
.exclusive-footer{
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

 ::v-deep {
        .el-rate__icon {
            font-size: 20px;
            margin-right: 2px;
        }

        .tabs-area {
            width: 100%;
            margin-bottom: 20px;

            .el-tabs__nav {
                border-radius: 0;
            }

            .el-tabs__header {
                margin-bottom: 0;
            }

            .el-tabs__nav .el-tabs__item {
                width: 170px;
                text-align: center;
                font-size: 14px;
                line-height: 40px;
                height: 40px;

                &.is-active {
                    background: #F4F7FF;
                    color: #0064C8;
                }

                &.is-active::after {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    content: '';
                    width: 100%;
                    height: 2px;
                    background: #0064C8;
                }
            }
        }
    }
</style>